import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  newButtonWrapper: {
    display: 'block',
  },
}))

export default useStyles
